import Vue from 'vue'
import Vuex from 'vuex'
import personal from './modules/personal'
import auth from './modules/auth'
import base from './modules/base'
import payment from './modules/payment'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    personal,
    base,
    payment
  }
})
